import { FC } from "react";
import styles from "./ManagementWeCare.module.scss";
import { useTranslation } from "next-i18next";
import { H2, P3 } from "../../../../components/Typography";
import Image from "next/image";
import cl from "classnames";

interface IManagementWeCare {}
export const ManagementWeCare: FC<IManagementWeCare> = () => {
  const { t } = useTranslation("index", { keyPrefix: "managementPage.weCare" });
  return (
    <div className={styles.care}>
      <div className={cl(styles.container, styles.care__content)}>
        <div>
          <H2 className={styles.care__title}>{t("title")}</H2>
          <P3 className={styles.care__text}>{t("text")}</P3>
        </div>
        <Image
          className={styles.care__image}
          src={"/images/management/we-care.webp"}
          loader={({ src }) => src}
          width={664}
          height={335}
          alt=""
        />
      </div>
    </div>
  );
};
